var _TableCellContextView_view, _TableCellContextView_actions, _TableCellContextView_nodeType, _TableCellContextView_renderItem;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import React from 'react';
import { findParentDomRefOfType } from 'prosemirror-utils';
import { ErrorLoggerBoundary } from '../../../../react-utils/ErrorBoundary';
import { getReactRendererFromState } from '../../ReactRenderer';
import { TableCellFloatingButton } from './floating';
export class TableCellContextView {
    constructor(view, actions, cellNodeType) {
        _TableCellContextView_view.set(this, void 0);
        _TableCellContextView_actions.set(this, void 0);
        _TableCellContextView_nodeType.set(this, void 0);
        _TableCellContextView_renderItem.set(this, void 0);
        __classPrivateFieldSet(this, _TableCellContextView_view, view, "f");
        __classPrivateFieldSet(this, _TableCellContextView_actions, actions, "f");
        __classPrivateFieldSet(this, _TableCellContextView_nodeType, cellNodeType, "f");
        __classPrivateFieldSet(this, _TableCellContextView_renderItem, getReactRendererFromState(view.state).createItem('table-cell-tooltip', () => (React.createElement(ErrorLoggerBoundary, null,
            React.createElement(TableCellFloatingButton, { actions: __classPrivateFieldGet(this, _TableCellContextView_actions, "f"), dom: TableCellContextView.findCellDom(__classPrivateFieldGet(this, _TableCellContextView_view, "f"), __classPrivateFieldGet(this, _TableCellContextView_nodeType, "f")) })))), "f");
    }
    static findCellDom(view, nodeType) {
        return findParentDomRefOfType(nodeType, view.domAtPos.bind(view))(view.state.selection);
    }
    update(view) {
        __classPrivateFieldSet(this, _TableCellContextView_view, view, "f");
        __classPrivateFieldGet(this, _TableCellContextView_renderItem, "f").rerender();
    }
    destroy() {
        __classPrivateFieldGet(this, _TableCellContextView_renderItem, "f").remove();
    }
}
_TableCellContextView_view = new WeakMap(), _TableCellContextView_actions = new WeakMap(), _TableCellContextView_nodeType = new WeakMap(), _TableCellContextView_renderItem = new WeakMap();
